import $ from "jquery";

$(function () {

	let retryDelay = 15;
	let retryCountdown = retryDelay;
	let intervalHandle = null;

	$('#send_download_links').on('click', () => {
		$('.send-link-form').hide();
		$('.send-link-message').show();

		$('#reset_send_link_form').html('Try Again in ' + retryCountdown + ' seconds').attr('disabled', 'disabled');
		intervalHandle = setInterval(function () {
			retryCountdown--;
			$('#reset_send_link_form').html('Try Again in ' + retryCountdown + ' seconds');
			if (retryCountdown === -1) {
				clearInterval(intervalHandle);
				$('#reset_send_link_form').html('Try Again').removeAttr('disabled');
				retryDelay *= 2;
				retryCountdown = retryDelay;
			}
		}, 1000);

		let cell_number = $('#cell_number').val();
		if (cell_number !== '') {
			$.post(
				window.ADMIN_AJAX_URL,
				{
					action: 'send_download_links',
					cell_number
				},
				(response) => {
					if (response === 'success') {

					}
				}
			);
		}
	});

	$('#cell_number').on('keydown', (evt) => {
		if (evt.key === 'Backspace' || evt.key === 'ArrowLeft' || evt.key === 'ArrowRight') return;
		if(!(/^(?:[+\d].*\d|\d)$/).test(evt.key)) {
			evt.preventDefault();
		}
	});

	$('#cell_number').on('input', (evt) => {
		let value = evt.currentTarget.value;
		if (value.match(new RegExp(/^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$/, 'im'))) {
			$('#send_download_links').removeAttr('disabled');
		} else {
			$('#send_download_links').attr('disabled', 'disabled');
		}
	});

	$('#reset_send_link_form').on('click', () => {
		$('.send-link-form').show();
		$('.send-link-message').hide();
		$('#cell_number').val('');
	});
});
